import { Highlight } from '@curology/ui-components-web/react/Highlight';
import { Typography } from '@curology/ui-components-web/react/Typography';
import React from 'react';

import { type Card } from '@/types/productSelectionAndCheckout/types';

import { IngredientsAccordion } from '../IngredientsAccordion';
import { ModalImage } from '../ModalImage';
import { ModalPricingVolumeAndProductOptionSelector } from '../ModalPricingVolumeAndProductOptionSelector';

export const EyeFormulaModalContent = ({ modalCard }: { modalCard: Card }) => {
  const { modal } = modalCard;

  return (
    <>
      <ModalImage modal={modal} />
      <Typography className="cur-mt-4" size="h2">
        {modal.title}
      </Typography>
      <ModalPricingVolumeAndProductOptionSelector modalCard={modalCard} />
      {modalCard.recommendationText && (
        <Highlight className="cur-mt-4" state="success">
          <div
            dangerouslySetInnerHTML={{
              __html: modalCard.recommendationText.modalCallout,
            }}
          ></div>
        </Highlight>
      )}
      <Typography className="cur-mt-4">
        Personalized by your Licensed Dermatology Provider, your Eye Formula is
        designed with tretinoin* and a trusted blend of anti-aging ingredients
        to smooth fine lines and wrinkles around the eyes, including crow’s
        feet, while visibly brightening dark circles and evening skin tone.
      </Typography>
      <Typography className="cur-mt-4">
        This velvety balm also forms a protective shield over your delicate
        under-eye area to help lock in lasting hydration and soften skin.
      </Typography>
      <Typography className="cur-mt-4">
        *Subject to consultation. Not all formulations contain tretinoin.
        Results may vary. Restrictions apply.
      </Typography>
      <Typography className="cur-mt-4" size="h3">
        How to use it
      </Typography>
      <Typography className="cur-mt-4">
        After cleansing with your Cream Oil Cleanser in the evening, dispense
        half a pea-sized amount of Eye Formula to your finger. Gently apply to
        under-eye area, below the lash line and on crow’s feet. Avoid upper
        eyelids. Start by using 2-3 times a week for 2 weeks, then increase to
        daily use, as tolerated.
      </Typography>
      <Typography className="cur-mt-4" size="h3">
        Active ingredients
      </Typography>
      <Typography className="cur-mt-4">
        Your provider will prescribe up to 4 of the following active ingredients
        to include in your Eye Formula:
      </Typography>
      <IngredientsAccordion
        body="Helps smooth texture and fine lines while brightening skin"
        title="Tretinoin"
      />
      <IngredientsAccordion
        body="Helps smooth skin and slow down photoaging effects"
        title="Caffeine"
      />
      <IngredientsAccordion
        body="Minimizes hyperpigmentation and fights damaging free radicals"
        title="Green tea extract (epigallocatechin gallate)"
      />
      <IngredientsAccordion
        body="Attracts and holds moisture for softer, smoother skin"
        title="Dexpanthenol"
      />
      <IngredientsAccordion
        body="Locks water in the skin’s outer layer to maximize moisture levels"
        title="Glycerin"
      />
      <Typography className="cur-mt-4" size="h3">
        Inactive ingredients
      </Typography>
      <Typography className="cur-mt-4">
        Olus Oil, C30-45 Alkyl Methicone, C30-45 Olefin, Cetearyl Olivate, Cera
        Alba, Tocopheryl Acetate
      </Typography>
    </>
  );
};
